import React from "react";

const ScreenshotPreview = ({ screenshot, onClose }) => (
  <div
    className="fixed z-10 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      />

      <span
        className="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >
        &#8203;
      </span>

      <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle">
        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div>
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left flex items-center justify-center">
              <div className="relative">
                <img
                  className="bg-gray-500"
                  alt={screenshot.screenshot.title}
                  src={screenshot.screenshot.url}
                />
                <div
                  className="animate-ping	absolute border border-white bg-yellow-400 bg-opacity-75"
                  style={{
                    left: screenshot.coordinate.x,
                    top: screenshot.coordinate.y,
                    width: screenshot.coordinate.width,
                    height: screenshot.coordinate.height,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={() => onClose()}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default ScreenshotPreview;
